"use client";

import { createContext, useContext, ReactNode } from 'react';

interface MessageContextType {
  isLastMessage: boolean;
}

const MessageContext = createContext<MessageContextType>({
  isLastMessage: false
});

export const useMessageContext = () => {
  return useContext(MessageContext);
};

interface MessageProviderProps {
  children: ReactNode;
  isLastMessage: boolean;
}

export const MessageProvider: React.FC<MessageProviderProps> = ({
  children,
  isLastMessage
}) => {
  return (
    <MessageContext.Provider value={{ isLastMessage }}>
      {children}
    </MessageContext.Provider>
  );
};